import {
    Grid
} from "@mui/material";
import { compose } from "@reduxjs/toolkit";
import React, { Component } from "react";
import { connect } from "react-redux";
import { saveReport } from '../../Slice/report.slice';

import {
    showLoador,
    showNotification,
} from "../../Pages/Landing/Landing.slice";
import { ButtonCompo } from "../../components/Comman/Button";
import { LabelCompo } from "../../components/Comman/Label";
import { TextFieldCompo } from "../../components/Comman/TextFieldCompo";
import { withRouter } from "../../components/withRouter";
import { redColor, titleColor } from "../../config/ColorObj";
import endpoint from "../../config/endpoints";
import * as msgConstant from "../../config/messageconstant";
import { apiGet } from "../../utils/api_service";
import AddTableColoumnsPopUp from "./AddTableColoumnsPopUp";
import TableColumnsDetails from "./TableColumnsDetails";
let rowList = [
    {

        columnName: "Category Name",
        fieldName: "category",
        pojoFiledName: "category",
        allignment: "left",
        width: 200,
        isShow: 1,
        sortNo: 2,
        isTotal: 0,
        isList: 0
    },
    {

        columnName: "Short Name",
        fieldName: "shortName",
        pojoFiledName: "shortName",
        allignment: "left",
        width: 200,
        isShow: 1,
        sortNo: 2,
        isTotal: 0,
        isList: 0
    },
    {

        columnName: "Product List",
        fieldName: "productList",
        pojoFiledName: "productList",
        subList: [{
            columnName: "Product Name",
            fieldName: "productName",
            pojoFiledName: "productName",
            allignment: "left",
            width: 200,
            isShow: 1,
            sortNo: 2,
            isTotal: 0,
            subList: [{
                columnName: "Product Name",
                fieldName: "itemName",
                pojoFiledName: "itemName",
                allignment: "left",
                width: 200,
                isShow: 1,
                sortNo: 2,
                isTotal: 0,
                isList: 0
            },
            {
                columnName: "Product Short Name",
                fieldName: "shortName",
                pojoFiledName: "shortName",
                allignment: "left",
                width: 200,
                isShow: 1,
                sortNo: 2,
                isTotal: 0,
                isList: 0
            },
            ],
            isList: 1,
        },
        {
            columnName: "Product Short Name",
            fieldName: "shortName",
            pojoFiledName: "shortName",
            allignment: "left",
            width: 200,
            isShow: 1,
            sortNo: 2,
            isTotal: 0,
            isList: 0
        },
        ],
        isList: 1,
        allignment: "",
        width: 0,
        isShow: 1,
        sortNo: 0,
        isTotal: 0,

    },
    {

        columnName: "Product List",
        fieldName: "ItemList",
        pojoFiledName: "ItemList",
        subList: [{
            columnName: "Product Name",
            fieldName: "productName",
            pojoFiledName: "productName",
            allignment: "left",
            width: 200,
            isShow: 1,
            sortNo: 2,
            isTotal: 0,
            isList: 0,
        },
        {
            columnName: "Product Short Name",
            fieldName: "shortName",
            pojoFiledName: "shortName",
            allignment: "left",
            width: 200,
            isShow: 1,
            sortNo: 2,
            isTotal: 0,
            isList: 0
        },
        ],
        isList: 1,
        allignment: "",
        width: 0,
        isShow: 1,
        sortNo: 0,
        isTotal: 0,

    },
]
class ReportForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tableColumnsList: [],
            reportName: "",
            type: "",
            isGraph: "1",
            isSubReport: "0",
            formValidErrors: {},
            fieldData: {},
            fieldDataEdit: {},
            formErrors: {},
            editData: {},
            openDialog: false,
            rowData: {},
            freezColumn: "",
        };
    }

    componentDidMount() {
        const { showLoador, showNotification } = this.props;

        if (this.props.params.id) {
            if (navigator.onLine) {
                showLoador({ loador: true });
                apiGet({
                    url: endpoint.report + "/" + this.props.params.id,
                }).then(({ data, success }) => {
                    showLoador({ loador: false });
                    if (success) {
                        if (!data.error) {
                            if (Object.keys(data.data).length !== 0) {
                                let rowObject = data.data;
                                this.setState({ freezColumn: rowObject.freezColumn })
                            }
                        }
                    }
                    return success;
                });
            } else {
                showNotification({ msg: msgConstant.noInternetMsg, severity: "error" });
            }
        }

        this.setState({
            tableColumnsList: JSON.parse(this.props.report.reportData.tableColumns) != null ? JSON.parse(this.props.report.reportData.tableColumns) : [],
        });
    }
    onFormSave = () => {

        const tableData = this.state.tableColumnsList.sort(function (a, b) {
            return +a.sortNo - b.sortNo;
        });
        this.onSave({ ...this.props.report.reportData, tableColumns: JSON.stringify(tableData) })
        console.log(tableData)
    };

    onSave = (dataToSaveJson) => {
        const { freezColumn } = this.state;

        let dataToSave = {
            ...dataToSaveJson,
            freezColumn: freezColumn,
        }

        if (navigator.onLine) {
            const {
                saveReport,
                showLoador,
                showNotification,
            } = this.props;
            showLoador({ loador: true });
            saveReport({ dataToSave }).then(({ success }) => {
                showLoador({ loador: false });
                if (success) {
                    this.props.changeTab(4)
                    showNotification({
                        msg: dataToSave.id ? msgConstant.deletemsg : msgConstant.savemsg,
                    });

                } else {
                    showNotification({
                        msg: msgConstant.saveFailedMsg,
                        severity: "error",
                    });
                }
            });
        } else {
            showNotification({
                msg: msgConstant.noInternetMsg,
                severity: "error",
            });
        }
    };
    componentWillReceiveProps(nextProps) {
        if (nextProps.report != this.props.report) {
            if (nextProps.report.reportData != this.props.report.reportData) {
                console.log(nextProps.report.reportData)
                this.setState({
                    tableColumnsList: JSON.parse(nextProps.report.reportData.tableColumns) != null ? JSON.parse(nextProps.report.reportData.tableColumns) : [],
                });
            }
        }
    }
    onRadioChange = (event) => {
        this.setState({ isSubReport: event.target.value });
    };

    onCancel = () => {
        this.props.navigate(-1);
    };

    rowEdit = (rowData) => {
        this.setState({
            rowData: rowData
        })
        this.toggleFilter()
    }
    toggleFilter = () => {
        if (this.state.openDialog) {
            this.setState({
                rowData: {},
            })
        }
        this.setState({
            openDialog: !this.state.openDialog,
        })
    }


    changeHandler = (e) => {
        const { name, value } = e.target;
        if (name === "freezColumn") {
            this.setState({ freezColumn: value });
        }
    }

    render() {
        const { tableColumnsList, rowData, openDialog, freezColumn, formErrors } = this.state;
        return (
            <>

                <Grid container sx={{ marginTop: 2 }} spacing={1}>

                    <Grid
                        item
                        sm={12}
                        xs={12}
                        md={12}
                        lg={12}
                        container
                        justifyContent="flex-end"
                    >
                        <ButtonCompo
                            sx={{ color: 'white', backgroundColor: '#0f3f6f' }}
                            size="medium"
                            type="button"
                            variant="contained"
                            name={"Add"}
                            onClick={this.toggleFilter}
                            fullWidth={false}
                        />
                    </Grid>

                </Grid>
                <br />
                <TableColumnsDetails rowData={rowData} rowEdit={this.rowEdit} rowList={tableColumnsList} />
                <br />


                <Grid
                    item
                    sm={12}
                    xs={12}
                    md={12}
                    lg={12}
                    display='flex'
                // container
                // justifyContent="space-evenly"
                >
                    <Grid
                        item
                        sm={6}
                        xs={12}
                        md={6}
                        lg={6}
                        container
                        justifyContent="left"
                    >
                        <Grid item xs={12} md={3} sm={3}>
                            <LabelCompo
                                className="text-black"
                                style={{ fontSize: 16, color: redColor }}
                                label="*"
                            />
                            <LabelCompo
                                className="text-black"
                                style={{ fontSize: 16, color: titleColor }}
                                label="Excel Column Freeze :"
                            />
                        </Grid>
                        <Grid item xs={12} md={2} sm={2}>
                            <TextFieldCompo
                                placeHolder={"Enter Excel Column Freeze"}
                                color="primary"
                                name="freezColumn"
                                value={freezColumn}
                                type="number"
                                fullWidth
                                onChange={this.changeHandler}
                                errorText={
                                    formErrors["freezColumnError"] ? formErrors["freezColumnError"] : ""
                                }
                            />
                        </Grid>
                    </Grid>
                    &nbsp;&nbsp;
                    <Grid
                        item
                        sm={6}
                        xs={12}
                        md={6}
                        lg={6}
                        container
                        justifyContent="right"
                    >
                        <ButtonCompo
                            size="small"
                            type="submit"
                            variant="contained"
                            name="Save and Next"
                            // fullWidth={true}
                            onClick={this.onFormSave}
                        />
                    </Grid>
                </Grid>

                
                {
                    openDialog &&
                    <AddTableColoumnsPopUp openDialog={openDialog} tableColumnsList={tableColumnsList} rowDataEdit={rowData} setOpenDialouge={() => {
                        this.setState({
                            openDialog: false,
                            rowData: {},
                        })
                    }}
                    />}
            </>
        );
    }
}
const mapStateToProps = (state) => ({ report: state.report });
const mapDispatchToProps = { showLoador, showNotification, saveReport };
export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(ReportForm);
